import { render } from "./ElectionMap17.vue?vue&type=template&id=e8bc696a&scoped=true"
import script from "./ElectionMap17.vue?vue&type=script&lang=js"
export * from "./ElectionMap17.vue?vue&type=script&lang=js"

import "./ElectionMap17.vue?vue&type=style&index=0&id=e8bc696a&scoped=true&lang=css"

import exportComponent from "/Users/noursafadi/Documents/Uni/Parsons-Spring-25/MajorStudio02/MSDV-thesis-2025/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8bc696a"]])

export default __exports__